import React from 'react';
import "./footer.css";
import {Link} from "react-router-dom";
import {footer} from "../../data";


function App() {
  return <Footer52 {...footer52Data} />;
}

export default App;

function Footer52(props) {
  const {
    group85,
    place,
    overlapGroup,
    //vector2,
    phone,
    overlapGroup1,
    vector3,
    text15,
    text14,
    contactWebuildCom,
    quickLinks,
    aboutUs,
    projects,
    gallery,
    knowledgeTransfer,
    blogs,
    faqs,
    group872Props,
  } = props;

  return (
    <div  className="ft-footer">
      
      <div  className="ft-flex-row-1">
        {/* <img
           className="ft-vector"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        /> */}
        
        {/* <img  className="ft-group-85" src={group85} /> */}
          <Link to="/home">
          <img  className="ft-group-85" src={footer.Webuildd} />
          </Link> 
        <Group872
          facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
          facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
          twitterProps={group872Props.twitterProps}
        />
      </div>
      <div  className="ft-flex-row-2">
        <div  className="ft-group-32">
          <div  className="ft-place valign-text-middle ft-typographyheadlineh5-extrabold-20">{place}</div>
          <div  className="ft-flex-row-3">
            <div  className="ft-flex-col">
              <div  className="ft-map-pin-1">
                <div  className="ft-overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
                  {/* <img  className="ft-vector-1" src={vector2} /> */}
                </div>
              </div>
              <div className="ft-phone">  {/* Link is in style "style={{ backgroundImage: `url(${phone})` }}" */}
                <img src={footer.Phone}
                    width='18px'
                    height='18px'
                    />
              </div>
              <div  className="ft-mail">
                <div  className="ft-overlap-group1" >   {/* Link is in style "style={{ backgroundImage: `url(${overlapGroup1})` }}" */} 
                  {/* <img  className="ft-vector-2" src={vector3} /> */}

                 <img 
                 src={footer.Mail}
                 width='16px'
                 height='18px'
                 />

                </div>
              </div>
            </div>
            <div  className="ft-flex-col-1">
              <p  className="ft-text-2 ft-typography-body-smalltext-14-regular">{text15}</p>
              <div  className="ft-flex-col-item valign-text-middle ft-typography-body-smalltext-14-regular">{text14}</div>
              <div  className="ft-flex-col-item valign-text-middle ft-typography-body-smalltext-14-regular">
                {contactWebuildCom}
              </div>
            </div>
          </div>
        </div>
        <div  className="ft-group-147">
          <div  className="ft-quick-links valign-text-middle ft-typographyheadlineh5-extrabold-20">{quickLinks}</div>
          <div  className="ft-flex-row-4">
            <Link to = "/about">
              <div  className="ft-about-us valign-text-middle ft-typographybody16-regular">{aboutUs}</div>
            </Link>
            <Link to = "/project">
              <div  className="ft-projects valign-text-middle ft-typographybody16-regular">{projects}</div>
            </Link>
          </div>
          <div  className="ft-flex-row">
            <Link to = "/video">
              <div  className="ft-gallery valign-text-middle ft-typographybody16-regular">{gallery}</div>
            </Link>
            <Link to = "/">
              <div  className="ft-knowledge-transfer valign-text-middle ft-typographybody16-regular">{knowledgeTransfer}</div>
            </Link>
          </div>
          <div  className="ft-flex-row">
            <Link to = "/blog">
              <div  className="ft-blogs valign-text-middle ft-typographybody16-regular">{blogs}</div>
            </Link>
            <Link to = "/faq">
              <div  className="ft-fa-qs valign-text-middle ft-typographybody16-regular">{faqs}</div>
            </Link>
          </div>
        </div>
      </div>
      
    </div>
  );
}


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div  className="ft-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div  className="ft-facebook-app-symbol">
      {/* <img  className="ft-f-1" src={src} /> */}
      <img  className="ft-f-1" src={footer.Facebook} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div  className="ft-instagram">
      <div  className="ft-overlap-group-1" >    {/* Link is in style "style={{ backgroundImage: `url(${overlapGroup1})` }}" */}
        {/* <img
           className="ft-vector-3"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img  className="ft-vector-4" src={vector2} /> */}

          <img  src={footer.Instagram} 
            width='18px'
            height='18px'
            />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div  className="ft-twitter">
      {/* <img  className="ft-vector-5" src={src} /> */}
      <img  className="ft-vector-5" src={footer.Twitter} />
     
    </div>
  );
}

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/instagram-1@2x.svg",
    //vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    //src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d434f90f59a872fbd1cefc/img/twitter@2x.svg"
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

const footer52Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    place: "Contact",
    overlapGroup: "/Images/Footer/location-icon.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/phone-1@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-152@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-153@2x.svg",
    text15: "BSR Memoirs, No. 15, New BEL Road, Chikkamaranahalli, RMV 2nd Stage Bangalore 560094, Karnataka.",
    text14: "+91-9845408111",
    contactWebuildCom: "hari.krishna@webuildd.com",
    quickLinks: "Quick Links",
    aboutUs: "About Us",
    projects: "Projects",
    gallery: "Gallery",
    knowledgeTransfer: "Knowledge Transfer",
    blogs: "Blogs",
    faqs: "FAQ’s",
    group872Props: group872Data,
};

